import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { DayFlag, SelectionState, UI } from "../UI.js";
export function getClassNamesForModifiers(modifiers, classNames) {
  var modifiersClassNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var modifierClassNames = Object.entries(modifiers).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      active = _ref2[1];
    return active === true;
  }).reduce(function (previousValue, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    if (modifiersClassNames[key]) {
      previousValue.push(modifiersClassNames[key]);
    } else if (classNames[DayFlag[key]]) {
      previousValue.push(classNames[DayFlag[key]]);
    } else if (classNames[SelectionState[key]]) {
      previousValue.push(classNames[SelectionState[key]]);
    }
    return previousValue;
  }, [classNames[UI.Day]]);
  return modifierClassNames;
}